/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentListChatRequest {
    getFixupPrototypeFunction() { return AgentListChatRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentListChatRequest>): AgentListChatRequest {
        let obj = Object.assign(new AgentListChatRequest(), model);
        AgentListChatRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentListChatRequest>): AgentListChatRequest {
        if (!model) return null;
        return AgentListChatRequest.newInstance(<AgentListChatRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentListChatRequest) {
        if (!obj) return;

        models.AgentListChatRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentListChatRequest): boolean {
        Object.setPrototypeOf(obj, AgentListChatRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AgentChatFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AgentChatSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AgentChatSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AgentChatFilter;

}
